// Tabs ([data-tabs] with [data-tab] buttons and [data-tab-panel] panels in the same order): one panel at a
// time; arrow keys, Home and End move between the tabs. Without JS all panels stay visible.
export function initTabs() {
	document.querySelectorAll('[data-tabs]').forEach((box) => {
		const tabs = [...box.querySelectorAll('[data-tab]')]
		const panels = [...box.querySelectorAll('[data-tab-panel]')]
		const select = (index, focus) => {
			tabs.forEach((tab, i) => {
				const active = i === index
				tab.setAttribute('aria-selected', active ? 'true' : 'false')
				tab.tabIndex = active ? 0 : -1
				panels[i].hidden = !active
			})
			if (focus) tabs[index].focus()
		}
		tabs.forEach((tab, i) => {
			tab.addEventListener('click', () => select(i, false))
			tab.addEventListener('keydown', (event) => {
				const last = tabs.length - 1
				const next = { ArrowRight: i === last ? 0 : i + 1, ArrowLeft: i === 0 ? last : i - 1, Home: 0, End: last }[event.key]
				if (next === undefined) return
				event.preventDefault()
				select(next, true)
			})
		})
		box.classList.add('is-ready')
		select(0, false)
	})
}
